import React from 'react';
import classes from './SurveyTipItem.module.scss';
import { SURVEY_TIPS } from '../../pages/pages';
import { SurveyTip } from 'constants/surveyTips';
import Card from 'components/atoms/Card/Card';
import A from 'components/atoms/A/A';
import Txt from 'components/atoms/Txt/Txt';
import ChevronIcon from 'components/assets/ChevronIcon';

export interface Props {
  tip: SurveyTip;
  index: number;
}

const SurveyTipItem: React.FC<Props> = ({ tip, index }) => {
  const { title, icon, path } = tip;

  return (
    <Card interactive component={A} to={`${SURVEY_TIPS.path}/${path}`} className={classes.root}>
      <div className={classes.tipIconContainer}>
        <svg className={classes.tipIcon}>
          <image width="100%" height="100%" href={icon} />
        </svg>
      </div>
      <header className={classes.tipInfo}>
        <Txt
          component="p"
          className={classes.tipNumber}
          translateOptions={{ vars: [index + 1] }}
        >{`Tip %1s;`}</Txt>
        <Txt component="h2" className={classes.tipName}>
          {title}
        </Txt>
      </header>
      <div className={classes.chevronContainer}>
        <ChevronIcon className={classes.chevronIcon} color="#C3C5D0" />
      </div>
    </Card>
  );
};

export default SurveyTipItem;
